// import node module libraries
import { Fragment } from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

export const FormSelect = ({
  placeholder = "",
  value,
  defaultselected = "Select",
  options = [],
  id = "",
  name = "",
  style = "",
  onChange,
  required = false,
}) => {
  return (
    <Fragment>
      <Form.Select
        value={value}
        defaultValue={defaultselected}
        id={id}
        name={name}
        onChange={onChange}
        required={required}
        style={style ? style : {}}
        className="text-dark"
      >
        {placeholder && (
          <option value="" className="text-muted">
            {placeholder}
          </option>
        )}
        {options.map((item, index) => (
          <option key={index} value={item.value} className="text-dark">
            {item.label}
          </option>
        ))}
      </Form.Select>
    </Fragment>
  );
};

FormSelect.propTypes = {
  placeholder: PropTypes.string,
  defaultselected: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
};

export default FormSelect;
